// Happy Energy Doku – die App des Verkäufers (doku.…). In E1 die leere App
// mit Name, Symbol und Anmeldung, dazu die Technik-Proben (seit E2,
// Schritt 6 weg); seit E2 die Besichtigung draußen (PLAN.md, Abschnitt 5).

import { Anmeldung, appStarten } from "@happy-energy/oberflaeche";
import { Doku } from "./Doku.tsx";

appStarten(
  "doku",
  <Anmeldung app="doku" appName="Happy Energy Doku">
    {(ich, hilfen) => <Doku ich={ich} hilfen={hilfen} />}
  </Anmeldung>,
);
